import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-bank-transfer-confirm-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <div class="dialog-container">
      <div class="dialog-header">
        <mat-icon class="check-icon">check_circle_outline</mat-icon>
        <h2>Estamos verificando tu transferencia</h2>
      </div>
      <div class="dialog-body">
        <p>La acreditación puede demorar unos minutos.</p>
        <p>Verás el saldo actualizado en tu cuenta.</p>
      </div>
      <div class="dialog-actions">
        <button mat-raised-button color="primary" (click)="close()">Aceptar</button>
      </div>
    </div>
  `,
  styles: [`
    .dialog-container {
      padding: 24px;
      text-align: center;
    }
    .dialog-header {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
    }
    .check-icon {
      font-size: 48px;
      width: 48px;
      height: 48px;
      color: #4caf50;
    }
    .dialog-header h2 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
    }
    .dialog-body {
      margin: 20px 0;
      color: #666;
    }
    .dialog-body p {
      margin: 4px 0;
    }
    .dialog-actions {
      margin-top: 20px;
    }
    .dialog-actions button {
      width: 100%;
      padding: 10px;
      border-radius: 8px;
    }
  `]
})
export class BankTransferConfirmDialogComponent {
  constructor(private dialogRef: MatDialogRef<BankTransferConfirmDialogComponent>) {}

  close() {
    this.dialogRef.close();
  }
}
